import React from "react";
import ShowerShowTemplate from "./ShowTemplate";
import ChooseTemplateHeader from "../assets/resources/ChooseTemplateHeader";
import TemplateGrid from "../assets/resources/TemplateGrid";

const TEMPLATES = [
  { id: "classic",       name: "Classic",                          image: require("../assets/img/Shower/classic.png") },
  { id: "sakura",        name: "Sakura",                           image: require("../assets/img/Shower/sakura.png") },
  { id: "goldDots",      name: "Gold Dots",                        image: require("../assets/img/Shower/goldDots.png") },
  { id: "wreath",        name: "Gold Wreath",                      image: require("../assets/img/Shower/wreath.png") },
  { id: "marsalaFloral", name: "Marsala Burgundy Floral",          image: require("../assets/img/Shower/marsalaFloral.png") },
  { id: "silverGlitter", name: "Silver Glitter",                   image: require("../assets/img/Shower/silverGlitter.png") },
  { id: "goldGlitter",   name: "Rose Gold Glitter Flowers",        image: require("../assets/img/Shower/goldGlitter.png") },
  { id: "modernMinimalist", name: "Modern Minimalist", tag: "new", image: require("../assets/img/Shower/modernMinimalist.svg").default },
  { id: "botanicalSage",    name: "Botanical Sage",     tag: "new", image: require("../assets/img/Shower/botanicalSage.svg").default },
  { id: "gildedArch",       name: "Gilded Arch",        tag: "new", image: require("../assets/img/Shower/gildedArch.svg").default },
  { id: "custom",        name: "Place your pre-made design", tag: "your own", image: require("../assets/img/Other/CustomDesign.png") },
];

class ChooseTemplate extends React.Component {
  constructor() {
    super();
    this.template = "";
  }

  ChangeTemplate = (word) => {
    this.template = word;
    this.setState({ changed: true });
    window.scrollTo(0, 0);
  };

  render() {
    if (this.template !== "") {
      return <ShowerShowTemplate template={this.template} />;
    }
    return (
      <>
        <ChooseTemplateHeader category="Bridal shower" />
        <TemplateGrid
          templates={TEMPLATES}
          customFormPath="/Shower-Custom-Form"
          onSelect={this.ChangeTemplate}
        />
      </>
    );
  }
}

export default ChooseTemplate;
